export default "__VITE_ASSET__DQKYXrQg__"